import React, { Component } from 'react';
import PropTypes from 'prop-types';
import radium, { Style } from 'radium';
import { css } from 'emotion';
import Relay from 'react-relay/classic';
import * as DataService from 'helper/LearningSpaceServices/DataService';
import CurrentUser from 'helper/currentUser';
import {
  SnackBarHelper,
  ActivityIndicator,
  User,
  SquareBorderButton
} from '@lyearn-team/frontend-components';
import {
  getAssignmentCardForPeerReviewCard,
  getCardQuestionForReviewForCorrespondingQuestion
} from 'helper/LearningSpaceServices/utils/getOfferData';
import AssetTypeEnum from 'appConsts/AssetType';
import mutationSync from 'graphql/helpers/mutationSync';
import { fetchRelayQueryForCourse } from 'learner/views/learnerViewCards/utils/refetchAndSaveCourseData';

import formatData from './formatData';
import ReactMediaPlayer from '../../../../components/ReactMediaPlayer/ReactMediaPlayer';
import ReviewPeerQuestionItem from './ReviewPeerQuestionItem';

const user = new CurrentUser();

class QuestionAnswerItem extends Component {
  static styles = {};
  static contextTypes = {
    snackbar: PropTypes.func
  };

  allPeerQuestions = [];

  constructor(props, context) {
    super(props, context);
    this.allResponseArray = [];
  }

  state = {
    score: '',
    showEditGradePopup: false,
    editModeOn: false,
    reviewModeOn: false,
    answers: [],
    currentAnswerIndex: 0,
    correspondingQuestionId: '',
    contentId: '',
    currentReviewCount: 0,
    loading: true
  };

  async componentDidMount() {
    this.fetchSubmissionsForReview();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      !nextProps.rootQ.questionsForReview[0].peerSubmissionsForReview[0]
      || nextProps.rootQ.questionsForReview[0].peerSubmissionsForReview[0].user.pid
        !== (this.props.rootQ.questionsForReview[0].peerSubmissionsForReview[0]
          && this.props.rootQ.questionsForReview[0].peerSubmissionsForReview[0].user.pid)
    ) {
      this.allPeerQuestions.map(pq => pq && pq.refs.component.clearAllInputs());
      this.allResponseArray = [];
    }
  }

  getQuizAnswerView(response, options) {
    const responseArray = response.split(',');
    return responseArray.map((responseObj, index) => {
      if (!options[responseObj]) return null;
      return (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index}>
          {options[responseObj].text}
          {index < responseArray.length - 1 ? ', ' : null}
        </div>
      );
    });
  }

  getMainResponseArray(array) {
    const mainArray = [];
    array.forEach(response => mainArray.push({
      questionId: response.questionId,
      rating: response.rating || 0,
      responseText: response.responseText || '',
      responseType: response.responseType || ''
    })
    );
    return mainArray;
  }

  fetchSubmissionsForReview = async () => {
    this.setState({ loading: true });
    const userId = user.id();
    const courseId = this.props.course.pid;
    const course = await DataService.getOfferByIdLocally(courseId);
    const assignmentCard = getAssignmentCardForPeerReviewCard(course, this.props.rootQ.pid);
    const assignmentQuestion = assignmentCard.children[0];
    const correspondingQuestionId = assignmentQuestion._id;
    const { minReviewCount } = assignmentQuestion;
    const cardQuestionForReview = getCardQuestionForReviewForCorrespondingQuestion(
      course,
      correspondingQuestionId
    );
    const limit = minReviewCount;
    const contentId = cardQuestionForReview._id;
    const assetId = assignmentCard.children[0]._id;
    const allStateInteractions = await DataService.getStateInteractionByOfferId(courseId);
    const reviewedUserIds = allStateInteractions
      .filter(
        stateInterection => stateInterection.actorId === user.id()
          && stateInterection.interactionType === 'peerReview'
          && stateInterection.contentId === assetId
      )
      .map(interection => interection.userId);
    const responseObject = await DataService.fetchNextSubmissionReview(
      assetId,
      userId,
      limit,
      reviewedUserIds
    );
    const response = await responseObject.json();
    this.setState({
      answers: response,
      correspondingQuestionId,
      contentId,
      currentAnswerIndex: 0,
      currentReviewCount:
        this.props.rootQ.questionsForReview[0]
        && this.props.rootQ.questionsForReview[0].currentReviewCount,
      loading: false
    });
  };

  renderPeerName = (peerUser) => {
    const styles = QuestionAnswerItem.styles;
    return (
      <div
        style={[
          styles.peerReviewTitleWrapper,
          styles.displayFlexRow,
          styles.alignItemsCenter,
          styles.userAvatarWrapper
        ]}
      >
        <User
          picture={peerUser.picture}
          name=""
          size="medium"
          className={css`
            img {
              width: 32px !important;
              height: 32px !important;
              border-radius: 50% !important;
            }
          `}
        />
        {peerUser.name}
      </div>
    );
  };

  reviewSubmission = () => {
    this.setState({
      reviewModeOn: !this.state.reviewModeOn
    });
  };

  getAllPeerQResponse = (position, response, ratingType) => {
    let tempObj = {};

    this.props.rootQ.questionsForReview[0].peerSubmissionsForReview[0].peerReview.forEach(
      (que, i) => {
        if (i === position) {
          if (ratingType === 'slider') {
            tempObj = {
              questionId: que.pid,
              index: position,
              rating: (que.maxScore * parseFloat(response || 0)) / 10,
              responseText: (typeof response !== 'undefined' && response.toString()) || '0',
              responseType: ratingType
            };
          } else if (ratingType === 'text') {
            tempObj = {
              questionId: que.pid,
              index: position,
              rating: 0,
              responseText: response.toString(),
              responseType: ratingType
            };
          } else if (ratingType === 'quiz') {
            // eslint-disable-next-line no-restricted-globals
            if (que.options[response] && !isNaN(que.options[response].relativeScore)) {
              tempObj = {
                questionId: que.pid,
                index: position,
                rating: que.maxScore * parseFloat(que.options[response].relativeScore),
                responseText: response.toString(),
                responseType: ratingType
              };
            }
          }
        }
      }
    );

    this.allResponseArray[tempObj.index] = {
      questionId: tempObj.questionId,
      rating: tempObj.rating,
      responseText: tempObj.responseText,
      responseType: tempObj.responseType
    };
  };

  clearAllTemp = () => {
    this.allPeerQuestions.map(pq => pq && pq.refs.component.clearAllInputs());
  };

  // eslint-disable-next-line consistent-return
  postAllReviews = peerQuestions => async () => {
    if (this.allResponseArray.filter(r => !!r).length !== peerQuestions.length) {
      SnackBarHelper.showSnackbar({ label: 'Review all the questions.' });
      return false;
    }
    const { answers, currentAnswerIndex, correspondingQuestionId, contentId } = this.state;
    const courseId = this.props.course.pid;
    const allResponses = this.getMainResponseArray(this.allResponseArray);
    const userId = user.id();
    const userObject = { userId, companyId: user.companyId() };
    const currentAnswer = answers[currentAnswerIndex];
    const receiverId = currentAnswer.user.pid;
    const reviewedSubmissionId = currentAnswer.answer.id;
    const commandProperties = {
      offerId: courseId,
      receiverId,
      reviewedSubmissionId,
      reviews: allResponses,
      contentId,
      correspondingQuestionId
    };
    const isCommnad = true;
    const isAnonymous = true;
    const command = formatData(commandProperties, isCommnad, isAnonymous);
    try {
      await mutationSync({
        offerId: courseId,
        offerType: AssetTypeEnum.offer,
        command,
        userObject
      });
      await fetchRelayQueryForCourse(courseId, userId);
      this.setState(prevState => ({
        currentAnswerIndex: prevState.currentAnswerIndex + 1,
        currentReviewCount: prevState.currentReviewCount + 1,
        loading: true
      }));
      setTimeout(() => {
        this.setState({ loading: false });
      }, 1500);
      this.allResponseArray = [];
      SnackBarHelper.showSnackbar({
        label: 'Successfully submitted the response',
        duration: 5,
        status: 'success'
      });
    } catch (error) {
      console.log(error);
    }
  };

  reviewPeerQuestions(peerQuestions) {
    const styles = QuestionAnswerItem.styles;
    return (
      <div
        style={[
          styles.reviewPeerQuestionsWrapper,
          styles.displayFlexColumn,
          styles.alignItemsCenter
        ]}
      >
        <div style={[styles.reviewQuestionWrapper, styles.displayFlexColumn]}>
          {peerQuestions.map((question, index) => (
            <ReviewPeerQuestionItem
              ref={ref => (this.allPeerQuestions[index] = ref)}
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              rootQ={question}
              index={index}
              getAllPeerQResponse={this.getAllPeerQResponse}
            />
          ))}
        </div>
        <div style={[styles.footerWrapper, styles.displayFlexColumn]}>
          <div style={[styles.reviewActionWrapper, styles.displayFlexRow, styles.alignItemsCenter]}>
            <span
              style={[styles.doneButton, styles.displayFlexRow, styles.alignItemsCenter]}
              onClick={this.postAllReviews(peerQuestions)}
            >
              SUBMIT
            </span>
          </div>
        </div>
      </div>
    );
  }

  renderAnswer(answer) {
    const styles = QuestionAnswerItem.styles;
    let answerView = '';
    const answerType = answer.answerType.toUpperCase();
    if (answerType === 'TEXT') {
      answerView = <div style={styles.textAnswer}>
        {answer.response}
        {' '}
      </div>;
    } else if (answerType === 'EMPTY') {
      answerView = <div style={styles.textAnswer}>NOT ATTEMPTED</div>;
    } else if (answerType === 'IMAGE') {
      answerView = <img alt="" src={answer.response} style={styles.imageElement} />;
    } else if (answerType === 'VIDEO') {
      answerView = (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video controls={true} src={answer.response} style={styles.videoElement} />
      );
    } else if (answerType === 'AUDIO') {
      answerView = <ReactMediaPlayer autoPlay={false} src={answer.response} vendor="AUDIO" />;
    }
    return answerView;
  }

  renderPeerQuestionsView(peerQuestions) {
    const styles = QuestionAnswerItem.styles;
    return (
      <div style={styles.peerReviewsMainContainer}>
        <div
          style={[styles.peerReviewInst, styles.displayFlexRow, styles.justifyContentSpaceBetween]}
        >
          <span style={styles.peerReviewTitleText}>
            Based on the above submission, answer the following questions:
          </span>
        </div>
        {this.reviewPeerQuestions(peerQuestions)}
      </div>
    );
  }

  render() {
    const styles = QuestionAnswerItem.styles;
    const { currentReviewCount, loading, answers, currentAnswerIndex } = this.state;
    const lastItem = this.props.lastItem;
    const peerQuestions = this.props.rootQ.questionsForReview[0].peerSubmissionsForReview[0]
      && this.props.rootQ.questionsForReview[0].peerSubmissionsForReview[0].peerReview;
    const answer = answers[currentAnswerIndex] && answers[currentAnswerIndex].answer;
    const answerUser = this.props.rootQ.questionsForReview[0].peerSubmissionsForReview[0]
      && this.props.rootQ.questionsForReview[0].peerSubmissionsForReview[0].user;
    if (loading) {
      return (
        <div style={styles.loader}>
          <ActivityIndicator width={30} height={30} />
        </div>
      );
    }
    if (
      !this.props.previousCard.performance
      || this.props.previousCard.performance.completionStatus !== 'COMPLETE'
    ) {
      return (
        <div style={{ textAlign: 'center', paddingTop: '110px' }}>
          <div style={styles.mainLabel}>
            Peer submissions will be available here once you submit the previous assignment
          </div>
          <div style={styles.subLabel}>
            Here you will be able to review submisisons of your peers
          </div>
        </div>
      );
    }
    if (!peerQuestions || answers.length < 1) {
      return (
        <div style={{ textAlign: 'center', paddingTop: '110px' }}>
          <div style={styles.mainLabel}>No submissions to review on this assignment</div>
          <div style={styles.subLabel}>
            Here you will be able to review submissions of your peers
          </div>
        </div>
      );
    }
    if (!peerQuestions || !answer) {
      return (
        <div style={{ textAlign: 'center', paddingTop: '110px' }}>
          <div style={styles.mainLabel}>
            You have reviewed
            {' '}
            {currentReviewCount}
            {' '}
peer
            {' '}
            {currentReviewCount > 1 ? 'submissions' : 'submission'}
          </div>
          <SquareBorderButton
            style={styles.reviewMoreButton}
            text="Review more submissions"
            onClick={this.fetchSubmissionsForReview}
          />
        </div>
      );
    }

    return (
      <div
        style={[
          styles.qAnswerContainer,
          styles.displayFlexColumn,
          lastItem ? styles.lastContainerItem : null
        ]}
      >
        {!this.props.rootQ.showPeerName && (
          <div
            style={[
              styles.peerReviewTitleWrapper,
              styles.displayFlexRow,
              styles.justifyContentSpaceBetween
            ]}
          >
            <span style={styles.peerReviewTitleText}>
              Peer review
              {currentReviewCount + 1}
            </span>
          </div>
        )}
        <div style={[styles.answerContainer, styles.displayFlexColumn]}>
          {this.props.rootQ.showPeerName && this.renderPeerName(answerUser)}
          {this.renderAnswer(answer)}
          {this.renderPeerQuestionsView(peerQuestions)}
        </div>
        <Style rules={styles.classBased} />
      </div>
    );
  }
}

QuestionAnswerItem.styles = {
  classBased: {
    '.gradeInputWrapper hr': {
      border: '0px!important',
      outline: '0px!important'
    },
    '.cancelReviewIcon': {
      width: '14px',
      height: '14px',
      marginRight: '4px',
      position: 'relative'
    },
    '.cancelReviewIcon:before,.cancelReviewIcon:after': {
      position: 'absolute',
      content: '""',
      height: '14px',
      width: '3px',
      backgroundColor: '#9ea7b1',
      left: '6px'
    },
    '.cancelReviewIcon:before': {
      transform: 'rotate(45deg)'
    },
    '.cancelReviewIcon:after': {
      transform: 'rotate(-45deg)'
    }
  },
  loader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    height: '30vh',
    alignItems: 'flex-end'
  },
  displayFlexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  displayFlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  justifyContentSpaceBetween: {
    justifyContent: 'space-between'
  },
  alignItemsCenter: {
    alignItems: 'center'
  },
  qAnswerContainer: {
    marginBottom: '20px',
    paddingBottom: '20px'
  },
  lastContainerItem: {
    paddingBottom: '0px',
    marginBottom: '0px',
    borderBottom: '0px'
  },
  questionTextContainer: {
    marginBottom: '16px'
  },
  qCounter: {
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '500',
    letterSpacing: '0.1px',
    color: '#9ea7b1',
    textTransform: 'uppercase',
    marginBottom: '6px'
  },
  questionText: {
    fontSize: '14px',
    lineHeight: '20px',
    color: '#566068'
  },
  textAnswer: {
    fontSize: '14px',
    lineHeight: '19px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  videoElement: {
    width: '90%',
    margin: '0 auto',
    display: 'block',
    maxWidth: '100%',
    height: '300px'
  },
  imageElement: {
    maxWidth: '100%',
    width: '100%'
  },
  questionHeaderContainer: {
    justifyContent: 'space-between'
  },
  scoreColumn: {
    fontSize: '12px',
    lineHeight: '15px',
    fontWeight: '500',
    color: '#758da1',
    textTransform: 'uppercase'
  },
  peerReviewsMainContainer: {
    marginTop: '24px'
  },
  peerReviewTitleText: {
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '500',
    letterSpacing: '0.1px',
    color: '#9ea7b1',
    textTransform: 'uppercase'
  },
  reviewSubmissionText: {
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '500',
    color: '#4a90e2',
    textTransform: 'uppercase',
    cursor: 'pointer'
  },
  peerReviewTitleWrapper: {
    marginBottom: '12px'
  },
  submitButton: {
    width: '134px',
    height: '36px',
    borderRadius: '4px',
    background: '#00b6e8',
    color: 'white',
    textTransform: 'uppercase',
    justifyContent: 'center',
    fontSize: '13px',
    lineHeight: '18px',
    letterSpacing: '0.6px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  enterScoreText: {
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '500',
    letterSpacing: '0.1px',
    color: '#36465d',
    textTransform: 'uppercase'
  },
  enterScoreRow: {
    marginTop: '18px'
  },
  enterScoreContainer: {
    borderRadius: '2px',
    border: '1px solid #7b96ac',
    width: '67px',
    height: '32px',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#758da1',
    marginLeft: '6px',
    justifyContent: 'center'
  },
  scoreInputBox: {
    width: '20px',
    marginRight: '5px',
    border: '0px',
    outline: 'none',
    color: 'rgb(117, 141, 161)',
    fontSize: '12px',
    lineHeight: '14px',
    maxHeight: '14px'
  },
  editScoreIcon: {
    marginLeft: '14px',
    cursor: 'pointer'
  },
  scoreWrapper: {
    position: 'relative'
  },
  gradeOperationsWrapper: {
    position: 'absolute',
    background: 'white',
    boxShadow: '0 2px 4px 1px rgba(0, 0, 0, 0.12)',
    borderRadius: '2px',
    top: '28px',
    right: '0px',
    maxWidth: '173px'
  },
  gradeOperations: {
    fontSize: '15px',
    lineHeight: '17px',
    color: 'rgba(0, 0, 0, 0.8)',
    padding: '12px 24px 0px',
    alignItems: 'flex-end',
    width: '100%',
    boxSizing: 'border-box'
  },
  previouslyGradedByWrapper: {
    borderTop: '1px solid #dbe2e8',
    padding: '8.5px 24px 11px 24px',
    fontSize: '13px',
    lineHeight: '17px',
    color: '#767e86',
    alignItems: 'flex-end',
    width: '100%',
    boxSizing: 'border-box'
  },
  marginBottom12: {
    marginBottom: '12px'
  },
  gradeOpText: {
    cursor: 'pointer'
  },
  hintTextStyle: {
    bottom: '0px',
    fontSize: '12px',
    lineHeight: '14px'
  },
  cancelReviewSubmission: {
    fontSize: '13px',
    color: '#7b96ac',
    lineHeight: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    textTransform: 'uppercase'
  },
  reviewInstructions: {
    background: '#edf0f3',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#36465d',
    width: '100%',
    padding: '9px 26px',
    marginBottom: '20px'
  },
  reviewQuestionWrapper: {
    width: '100%'
  },
  noteWrapper: {
    fontSize: '14px',
    lineHeight: '18px',
    color: '#767e86',
    margin: '18px 0 12px'
  },
  checkBoxContainer: {
    marginRight: '7px'
  },
  postAnonymous: {
    fontSize: '14px',
    lineHeight: '16px',
    color: '#36465d'
  },
  checkBox: {},
  buttonWrapper: {
    marginRight: '22px'
  },
  doneButton: {
    borderRadius: '2px',
    padding: '17px 96px',
    background: '#00b6e8',
    color: 'white',
    textTransform: 'uppercase',
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '600',
    letterSpacing: '0.6px',
    textAlign: 'center',
    cursor: 'pointer'
  },
  cancelButton: {
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '500',
    color: '#7b96ac',
    cursor: 'pointer',
    textTransform: 'uppercase'
  },
  footerWrapper: {
    width: '100%'
  },
  reviewActionWrapper: {
    padding: '55px 10px 0px',
    justifyContent: 'center'
  },
  mainLabel: {
    fontSize: '16px',
    fontWeight: '500'
  },
  subLabel: {
    fontSize: '14px',
    color: '#999',
    paddingTop: '12px'
  },
  reviewMoreButton: {
    marginTop: '12px'
  },
  peerReviewInst: {
    marginBottom: '24px'
  },
  userAvatar: {
    marginRight: '4px'
  },
  userAvatarWrapper: {
    fontSize: '14px'
  }
};

export default Relay.createContainer(radium(QuestionAnswerItem), {
  initialVariables: {
    userId: null
  },
  fragments: {
    rootQ: () => Relay.QL`
      fragment on Card {
        id
        pid
        name
        showPeerName
        questionsForReview{
          pid
          currentReviewCount
          peerSubmissionsForReview(fetchReviewed: false) {
            id
            isReviewed
            peerReview {
              pid
              question
              rType
              rating
              responseText
              maxScore
              ${ReviewPeerQuestionItem.getFragment('rootQ')}
              options{
                text
                correct
                relativeScore
              }
            }
            answer{
              response
              thumbUrl
              answerType
            }
            user{
              id
              pid
              name
              picture
              realEmail
            }
          }
        }
      }
    `
  }
});
